export default "__VITE_ASSET__1540b249__"